import { useState } from 'react';

export default (pickerModalEntityTypeProp, closePickerModal) => {
  const [pickerModalEntityTypeState, setPickerModalEntityTypeState] = useState(null);
  const onClosePickerModal = () => {
    setPickerModalEntityTypeState(null);
    closePickerModal && closePickerModal();
  };
  const pickerModalEntityType = pickerModalEntityTypeProp || pickerModalEntityTypeState;
  return {
    pickerModalEntityType,
    setPickerModalEntityType: setPickerModalEntityTypeState,
    onClosePickerModal
  };
};
